<!-- 账号管理 -->
<template>
  <div class="userlist">
    <div class="container">
      <!-- 面包屑 -->
      <div class="bread">
        <span class="bread-tab">账号管理</span>
      </div>
      <!-- 内容 -->
      <div class="show-box">
        <!-- 新增 -->
        <div class="show-add">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addOrUpdateHandle()"
            class="green-creat-button"
            size="mini"
          >新增用户</el-button>
        </div>
        <!-- 列表 -->
        <div class="show-table">
          <el-table :data="dataList" stripe size="mini" style="width: 100%; ">
            <el-table-column prop="username" label="账号" align="center"></el-table-column>
            <el-table-column prop="address" label="管理区域" align="center">
              <template slot-scope="scope">
                <el-popover
                  placement="right"
                  width="600"
                  trigger="click"
                  popper-class="rules_popper"
                  v-if="scope.row.userPracticeAreaList && scope.row.userPracticeAreaList.length > 0 && scope.row.areaStatus == 0"
                >
                  <div class="rules_list">
                    <ul>
                      <li>
                        <div class="rules_title">区域地址：</div>
                      </li>
                      <li v-for="(item,index) of scope.row.userPracticeAreaList" :key="index">
                        <div
                          class="rules_content"
                        >{{(item.provinceName || '') + ( item.cityName && item.cityName != null ?('-' + item.cityName || '') :'') + ( item.areaName && item.areaName != null ?('-' + item.areaName || '') :'')}}</div>
                      </li>
                    </ul>
                  </div>
                  <span slot="reference">查看管理区域</span>
                </el-popover>
                <span v-else-if="scope.row.areaStatus == 1">全部</span>
                <span v-else>无</span>
              </template>
            </el-table-column>
            <el-table-column prop="mobile" label="联系方式" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="deletes(scope.row)">删除</el-button>
                <el-button type="text" size="mini" @click="addOrUpdateHandle(scope.row)">编辑</el-button>
                <el-button type="text" size="mini" @click="resetPassword(scope.row)">重置密码</el-button>
                <!-- <el-button type="text" size="mini" @click="modifyPassword(scope.row)">修改密码</el-button> -->
              </template>
            </el-table-column>
          </el-table>
          <div class="page-wrap">
            <div class="muiltiOpiton"></div>
            <el-pagination
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
              :current-page="listPage.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="listPage.size"
              size="small"
              :total="totalPage"
              layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dataForm.userId?'编辑':'新增'"
      :close-on-click-modal="false"
      :visible.sync="userVisible"
      :append-to-body="true"
      :modal="true"
      width="50%"
    >
      <div class="user-dialog">
        <el-form
          ref="userForm"
          :rules="rules"
          class="el-form-ad"
          :model="dataForm"
          label-width="100px"
        >
          <el-form-item label="账号" prop="username">
            <el-input size="small" clearable v-model.trim="dataForm.username" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input size="small" clearable v-model.trim="dataForm.mobile" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="区域管理" prop="areaStatus">
            <el-radio-group size="small" v-model="dataForm.areaStatus">
              <el-radio :label="1">全部</el-radio>
              <el-radio :label="0">自定义</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="选择区域"
            prop="area"
            class="form-area-cascader"
            v-if="dataForm.areaStatus == 0"
          >
            <el-cascader
              v-model="dataForm.area"
              :props="{ checkStrictly: true }"
              :options="arealist"
              ref="areaCascaderlist"
              clearable
              size="small"
              placeholder="请选择管理区域"
              @change="handleChange"
            ></el-cascader>
            <div class="area-show-list">
              <span
                class="area-show-item"
                v-for="(item,index) of dataForm.userPracticeAreaList"
                :key="index"
              >
                {{ (item.provinceName?item.provinceName : '无省份') + ( item.cityName ? '-' + item.cityName : '') + (item.areaName?'-' + item.areaName : '') }}
                <i
                  class="el-icon-error"
                  @click="deleteArea(item)"
                ></i>
              </span>
            </div>
            <!-- dataForm.userPracticeAreaList -->
          </el-form-item>
          <el-form-item label="管理员权限" prop="authStatus">
            <el-radio-group size="small" v-model="dataForm.authStatus">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="启用状态" prop="status">
            <el-radio-group size="small" v-model="dataForm.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="2">停用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="addBtn">保存</el-button>
            <el-button size="small" @click="addCansal">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 修改密码弹窗 -->
    <!-- <el-dialog
      title="修改密码"
      :close-on-click-modal="false"
      :visible.sync="modflyPasswordVisible"
      :append-to-body="true"
      :modal="true"
      width="40%"
    >
      <div class="modflyPassword">
        <el-form
          ref="modflyForm"
          :rules="rules"
          class="el-form-ad"
          :model="modflyForm"
          label-width="100px"
        >
          <el-form-item label="原始密码" prop="oldPassword">
            <el-input
              size="small"
              show-password
              v-model.trim="modflyForm.oldPassword"
              placeholder="请输入原始密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input
              size="small"
              show-password
              v-model.trim="modflyForm.newPassword"
              placeholder="请输入新密码"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="modflyBtn">确认修改</el-button>
            <el-button size="small" @click="modflyCansal">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>-->
  </div>
</template>
<script>
import { Button, Input, Select, Option, Dialog, TableColumn, Table, Pagination, Popover, RadioGroup, Form, FormItem, DatePicker, Radio, Cascader } from 'element-ui'
export default {
  components: {
    'el-button': Button,
    'el-input': Input,
    'el-select': Select,
    'el-option': Option,
    'el-dialog': Dialog,
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-pagination': Pagination,
    'el-popover': Popover,
    'el-radio-group': RadioGroup,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-date-picker': DatePicker,
    'el-radio': Radio,
    'el-cascader': Cascader
  },
  data () {
    var validateUsername = (rule, value, callback) => {
      // eslint-disable-next-line
      var pattern = /[`~!@#$^&_*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]/g // 特殊字符
      // var alphanumericReg = new RegExp('^(?![0-9]+$)(?![a-zA-Z]+$)') // 必须是字母与数字结合
      if (pattern.test(value)) {
        callback(new Error('用户名不能包含特殊字符或空格!'))
      } else if (/[\u4E00-\u9FA5]/g.test(value)) {
        callback(new Error('用户名不能为中文!'))
      } else {
        callback()
      }
    }
    var validatePassword = (rule, value, callback) => {
      // eslint-disable-next-line
      var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]")
      // var pattern = /[`~!@#$^&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]/g // 特殊字符
      // var alphanumericReg = /^(?=.*[a-z])(?=.*[A-Z])[^]{6,18}$/ // 必须是字母与数字结合
      // if (!pattern.test(value)) {
      //   callback(new Error('密码必须包含特殊字符'))
      // }
      // if (!alphanumericReg.test(value)) {
      //   callback(new Error('密码必须是大写字母、小写字母，且位数在6至18位之间'))
      // } else
      if (/[\u4E00-\u9FA5]/g.test(value)) {
        callback(new Error('用户名不能为中文!'))
      } else {
        callback()
      }
    }
    var validateMobile = (rule, value, callback) => {
      // eslint-disable-next-line
      var isMobile = /(^1[3|4|5|7|8]\d{9}$)|(^09\d{8}$)/
      if (value === '' || value == null) {
        callback()
      } else if (!isMobile.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      pickerOptions: {
        disabledDate (time) {
          // //console.log(this.formatDateTime(time))
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      // 列表数据总条数
      totalPage: 0,
      // 分页参数
      listPage: {
        size: 20, // 每页显示条目个数
        page: 1 // 当前页数
      },
      dataList: [],
      dataForm: {
        userId: '',
        username: '',
        mobile: '',
        areaStatus: 1,
        area: [],
        userPracticeAreaList: [],
        authStatus: 1,
        status: 1
      },
      modflyForm: {
        oldPassword: '',
        newPassword: ''
      },
      arealist: [], // 省市区存储数据
      userVisible: false,
      modflyPasswordVisible: false,
      // ===========================================================
      // 表单验证
      rules: {
        mobile: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' }
        ],
        username: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
          { min: 6, max: 18, message: '用户名长度在 6 到 18 之间', trigger: 'blur' },
          { validator: validateUsername, trigger: 'blur' }
        ],
        oldPassword: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { min: 6, max: 18, message: '密码长度在 6 到 18 之间', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { min: 6, max: 18, message: '密码长度在 6 到 18 之间', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    // 新增.编辑弹窗关闭侦听
    userVisible (val) {
      if (val === false) {
        Object.assign(this.$data.dataForm, this.$options.data().dataForm)
      }
    },
    // 区域选取（如果选择全部。则清空省市区存储参数）
    'dataForm.areaStatus': function (val) {
      if (val === 1 || val === '1') {
        this.dataForm.area = ''
        this.dataForm.userPracticeAreaList = []
      }
    },
    // 修改密码侦听
    modflyPasswordVisible (val) {
      if (val === false) {
        Object.assign(this.$data.modflyForm, this.$options.data().modflyForm)
      }
    }
  },
  created () {
    // 获取省市区三级联动数据
    this.getAreainfo((res) => {
      this.arealist = res
    })
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    getDataList () {
      this.$http({
        method: 'post',
        url: '/sys/user/list',
        params: {
          pagesize: this.listPage.size,
          page: this.listPage.page
        }
      }).then(res => {
        if (res.rows) {
          this.dataList = res.rows
          this.totalPage = res.records
        }
      }).catch(error => {
        console.log(error)
        return false
      })
    },
    // 新增/编辑
    addOrUpdateHandle (row) {
      if (!row) {
        this.userVisible = true
      } else {
        this.dataForm.userId = row.userId
        this.dataForm.username = row.username
        this.dataForm.mobile = row.mobile
        this.dataForm.status = row.status
        this.dataForm.areaStatus = row.areaStatus
        this.dataForm.authStatus = row.authStatus
        if (row.userPracticeAreaList && row.userPracticeAreaList !== null && row.userPracticeAreaList.length > 0) {
          for (let i = 0; i < row.userPracticeAreaList.length; i++) {
            let newobj = {}
            const e = row.userPracticeAreaList[i]
            if (e.provinceId && e.provinceId !== null && e.provinceId !== '') {
              newobj.provinceId = e.provinceId
              newobj.provinceName = e.provinceName
            }
            if (e.cityId && e.cityId !== null && e.cityId !== '') {
              newobj.cityId = e.cityId
              newobj.cityName = e.cityName
            }
            if (e.areaId && e.areaId !== null && e.areaId !== '') {
              newobj.areaId = e.areaId
              newobj.areaName = e.areaName
            }
            this.dataForm.userPracticeAreaList.push(newobj)
          }
        }
        this.userVisible = true
      }
    },
    // 重置密码
    resetPassword (row) {
      this.$confirm('确定是否重置密码?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          method: 'post',
          url: '/sys/user/reset/password',
          data: {
            userId: row.userId
          }
        }).then(res => {
          if (res.code === 100) {
            this.$alert(res.result + '，请记住该密码', '重置密码', {
              confirmButtonText: '确定',
              callback: action => {
                this.getDataList()
              }
            })
          } else {
            this.$message.info(res.msg || res.result.msg)
          }
        }).catch(error => {
          console.log(error)
          return false
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消重置'
        })
      })
    },
    // 修改密码
    modifyPassword (row) {
      this.modflyPasswordVisible = true
    },
    // 确定修改密码
    modflyBtn () {
      this.$confirm('确定修改当前密码?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var paramas = new URLSearchParams()
        paramas.append('oldPassword', this.modflyForm.oldPassword)
        paramas.append('newPassword', this.modflyForm.newPassword)
        this.$http({
          method: 'post',
          url: '/sys/user/password',
          data: paramas
        }).then(res => {
          if (res.code === 100) {
            this.$message({
              type: 'success',
              message: '修改成功!'
            })
            this.getDataList()
            this.modflyPasswordVisible = false
          } else {
            this.$message.info(res.msg || res.result.msg)
          }
        }).catch(error => {
          console.log(error)
          return false
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消修改'
        })
      })
    },
    // 取消修改密码
    modflyCansal () {
      this.modflyPasswordVisible = false
    },
    // 删除
    deletes (row) {
      this.$confirm('确定是否删除该账号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          method: 'post',
          url: '/sys/user/delete',
          data: {
            userIds: [row.userId]
          }
        }).then(res => {
          if (res.code === 100) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getDataList()
          } else {
            this.$message.info(res.msg || res.result.msg)
          }
        }).catch(error => {
          console.log(error)
          return false
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除'
        })
      })
    },
    // 保存
    addBtn () {
      let formdata = {
        username: this.dataForm.username,
        mobile: this.dataForm.mobile,
        status: this.dataForm.status,
        areaStatus: this.dataForm.areaStatus,
        authStatus: this.dataForm.authStatus,
        userPracticeAreaList: this.dataForm.userPracticeAreaList
      }
      if (this.dataForm.userId === '') {
        this.$http({
          method: 'post',
          url: '/sys/user/save',
          data: formdata
        }).then(res => {
          if (res.code === 100) {
            this.$alert(res.result + '，请记住该密码', '获取密码', {
              confirmButtonText: '确定',
              callback: action => {
                this.getDataList()
                this.userVisible = false
              }
            })
          } else {
            this.$message.info(res.msg || res.result.msg)
          }
        }).catch(error => {
          console.log(error)
          return false
        })
      } else {
        formdata.userId = this.dataForm.userId
        this.$http({
          method: 'post',
          url: '/sys/user/update',
          data: formdata
        }).then(res => {
          if (res.code === 100) {
            this.$message.success('编辑成功')
            this.getDataList()
            this.userVisible = false
          } else {
            this.$message.info(res.msg || res.result.msg)
          }
        }).catch(error => {
          console.log(error)
          return false
        })
      }
    },
    // 取消保存
    addCansal () {
      this.userVisible = false
    },
    // 省市区三级联动选择事件
    handleChange (items) {
      if (items.length <= 0) {
        return false
      } else {
        let arealist = this.$refs['areaCascaderlist'].getCheckedNodes()[0].pathNodes
        if (arealist && arealist.length > 0) {
          let newSlit = {}
          arealist.forEach((item, index) => {
            if (item.label && item.value) {
              if (item.level === 1) {
                newSlit.provinceId = item.value
                newSlit.provinceName = item.label
              } else if (item.level === 2) {
                newSlit.cityId = item.value
                newSlit.cityName = item.label
              } else if (item.level === 3) {
                newSlit.areaId = item.value
                newSlit.areaName = item.label
              }
            }
          })
          if (this.dataForm.userPracticeAreaList.length <= 0) {
            this.dataForm.userPracticeAreaList.push(newSlit)
            // 最后删除选中框中的值
            window.setTimeout(() => {
              this.dataForm.area = ''
              this.$message.success('添加成功')
            }, 200)
          } else if (this.areaRepeat(newSlit)) {
            this.$message.info('已添加过该区域，请重新选择。')
          } else {
            this.dataForm.userPracticeAreaList.push(newSlit)
            // 最后删除选中框中的值
            window.setTimeout(() => {
              this.dataForm.area = ''
              this.$message.success('添加成功')
            }, 200)
          }
        }
      }
    },
    // 区域选择，判断是否重复
    areaRepeat (obj) {
      let isRepeat = false
      for (let i = 0; i < this.dataForm.userPracticeAreaList.length; i++) {
        const e = this.dataForm.userPracticeAreaList[i]
        if (obj.provinceId && e.provinceId && obj.provinceId === e.provinceId) {
          if (obj.cityId && e.cityId && obj.cityId === e.cityId) {
            if (obj.areaId && e.areaId && obj.areaId === e.areaId) {
              isRepeat = true
              break
            } else if (!obj.areaId && !e.areaId) {
              isRepeat = true
              break
            } else {
              isRepeat = false
              continue
            }
          } else if (!obj.cityId && !e.cityId && !obj.areaId && !e.areaId) {
            isRepeat = true
            break
          } else {
            isRepeat = false
            continue
          }
        } else {
          isRepeat = false
          continue
        }
      }
      return isRepeat
    },
    // 删除选中区域
    deleteArea (areaItem) {
      if (this.dataForm.userPracticeAreaList.indexOf(areaItem) > -1) {
        let index = this.dataForm.userPracticeAreaList.indexOf(areaItem)
        this.dataForm.userPracticeAreaList.splice(index, 1)
      }
    },
    // 每页数
    sizeChangeHandle (val) {
      this.listPage.size = val
      this.listPage.page = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.listPage.page = val
      this.getDataList()
    }
  }
}
</script>
<style src='./user.scss' lang="scss" scoped></style>
<style lang="scss">
.userlist {
  .el-popover__reference {
    white-space: initial;
    color: #2178ec;
    cursor: pointer;
  }
}
.form-area-cascader .el-cascader {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/user/user.vue